import { observer } from 'mobx-react-lite'
import { Box, Button } from 'shared/ui'
import { useKeyGenerator } from 'shared/hooks'
import { type IChatbotActionModel, type IChatbotActionType } from 'entities/Chatbot'
import type { IEntitiesStore } from 'entities/EntitiesExport'
import { ActionsDropdown } from 'pages/chatbot/ui/ActionsDropdown/ActionsDropdown'
import { ActionCard } from 'pages/chatbot/ui/ChatbotEdit/ChatbotActions/ActionCard'
import { type ChatbotAction } from 'pages/chatbot/store/chatbotActionStore'
import styles from './styles.module.scss'
import { ACTION_ITEMS, ACTIONS_CONFIG } from './config'

export const GoalActions = observer(
  ({ actions, entities }: { actions: ChatbotAction | null; entities: IEntitiesStore }) => {
    const getActionKey = useKeyGenerator<IChatbotActionModel>()

    if (!actions) return null

    const handleAddAction = (type: IChatbotActionType) => actions.createAction(type, entities)
    const handleDelete = (index: number, action: IChatbotActionModel) => {
      actions.removeAction(index)
      actions.actionErrors?.removeError(action)
    }

    return (
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'center'}
        alignItems={'center'}
        gap={1.5}
      >
        <div className={styles.actionCardsList}>
          {!!actions.list.length &&
            actions.list.map((action, index) => {
              const { icon, title, Component } = ACTIONS_CONFIG[action.type]

              return (
                <ActionCard
                  key={getActionKey(action)}
                  icon={icon}
                  title={title}
                  onDelete={() => handleDelete(index, action)}
                >
                  <Component
                    control={actions.getActionStore(action, entities)}
                    errors={actions.actionErrors}
                    action={action}
                  />
                </ActionCard>
              )
            })}
        </div>
        <ActionsDropdown
          dropdownWidth={175}
          handleAddAction={handleAddAction}
          items={ACTION_ITEMS}
          triggerComponent={() => (
            <Button
              icon='add'
              text='Add action'
              contained='secondary'
              size='medium'
              typeBtn='text'
            />
          )}
        />
      </Box>
    )
  }
)
